// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"380":"e1fdcd80","743":"fa167636"}[chunkId] + ".chunk.css";
};